// extracted by mini-css-extract-plugin
export default {"treeSelect":"userFullScopeComponent_treeSelect__9Mbzv"};